import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { ArrowUp, EyeVisible, Globe, Save } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export interface RequestTypeDetailHeaderProps {
  hasLocalChanges: boolean
  isPublished: boolean
  shouldPublish: boolean
  title: string
  onPreviewForm: () => void
  onPublish: () => void
  onSave: () => void
}

export function RequestTypeDetailHeader({
  hasLocalChanges,
  isPublished,
  shouldPublish,
  title,
  onPreviewForm,
  onPublish,
  onSave,
}: RequestTypeDetailHeaderProps) {
  return (
    <>
      <ResourceHeader
        title={title}
        primaryAction={{
          label: isPublished
            ? i18n.t(
                'procurement.purchase_requests.settings.types.modals.publish.buttons.publish_changes'
              )
            : i18n.t('common.publish'),
          icon: isPublished ? ArrowUp : Globe,
          onClick: onPublish,
          disabled: shouldPublish,
        }}
        secondaryActions={[
          {
            label: i18n.t('common.preview'),
            icon: EyeVisible,
            onClick: onPreviewForm,
          },
          {
            label: i18n.t('common.save'),
            onClick: onSave,
            disabled: !hasLocalChanges,
            icon: Save,
          },
        ].filter(Boolean)}
        status={{
          label: i18n.t('procurement.types.forms.status.label'),
          text: isPublished
            ? i18n.t('procurement.types.forms.status.published')
            : i18n.t('procurement.types.forms.status.draft'),
          variant: isPublished ? 'positive' : 'neutral',
        }}
      />
    </>
  )
}
